import { render, staticRenderFns } from "./v-role-item.vue?vue&type=template&id=3f947d65&"
import script from "./v-role-item.vue?vue&type=script&lang=js&"
export * from "./v-role-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports